// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2W9XY","error":"Textarea_error__3PmjD","readonly":"Textarea_readonly__1oXd1","disabled":"Textarea_disabled__DxQot"};